<!-- Formulario de captura de artículo -->
<div class="titulo" style="margin: 0 auto; text-align: center; margin-top: 50px;">
  <h3><b>Recargar Stock</b></h3>
  <hr>
</div>

<!-- Banner de folio fijado (aparece a partir del segundo artículo) -->
<div *ngIf="folioYaCapturado"
     class="alert alert-info d-flex align-items-center mx-3 mt-2"
     style="border-left: 5px solid #0d6efd; font-size: 0.95rem;">
  <span class="mdi mdi-receipt me-2" style="font-size: 1.3rem;"></span>

  <span>
    <strong>Número consecutivo activo:&nbsp;</strong>
    <span class="badge bg-primary fs-6 px-3 py-1">{{ numeroConsecutivoFijado }}</span>
    &nbsp;— todos los artículos de esta carga usarán los mismos datos fijos.
  </span>

</div>

<div class="formulario" style="margin: 0 auto; float: none;">

  <form (ngSubmit)="AgregarATabla(f)" #f="ngForm" style="width: 100%;">

    <!-- FILA 1: Número consecutivo | Fecha de compra | Proveedor | Ejercicio | Folio factura -->
    <div class="form-row mt-4" style="margin: 0 auto; width: 100%;">

      <!-- 1. Número consecutivo -->
      <div class="form-group col-md-2">
        <label>Número consecutivo</label>
        <ng-container *ngIf="!folioYaCapturado">
          <input [(ngModel)]="Recargastock.numeroConsecutivo"
                 type="text"
                 class="form-control"
                 name="NumeroConsecutivo"
                 placeholder="Ej. REC-001"
                 (ngModelChange)="actualizarHabilitados()"
                 required>
        </ng-container>
        <ng-container *ngIf="folioYaCapturado">
          <input type="text" class="form-control bg-light text-muted" [value]="numeroConsecutivoFijado" readonly>
          <small class="text-muted"><span class="mdi mdi-lock-outline"></span> Número bloqueado</small>
        </ng-container>
      </div>

      <!-- 2. Fecha de compra -->
      <div class="form-group col-md-2">
        <label>Fecha de compra</label>
        <ng-container *ngIf="!folioYaCapturado">
          <input [(ngModel)]="Recargastock.fechaAd"
                 type="date"
                 class="form-control"
                 name="FechaAdqui"
                 (ngModelChange)="actualizarHabilitados()"
                 required>
        </ng-container>
        <ng-container *ngIf="folioYaCapturado">
          <input type="text" class="form-control bg-light text-muted" [value]="fechaCompraFijada" readonly>
          <small class="text-muted"><span class="mdi mdi-lock-outline"></span> Fecha bloqueada</small>
        </ng-container>
      </div>

      <!-- 3. Proveedor -->
      <div class="form-group col-md-4">
        <label>Proveedor</label>
        <select [(ngModel)]="direccionSeleccionada"
                class="form-control"
                name="Proveedor"
                (change)="CapturarValor(); actualizarHabilitados()"
                required
                #Proveedor="ngModel"
                [disabled]="!proveedorHabilitada">
          <option value="" disabled selected>Seleccione el proveedor...</option>
          <option *ngFor="let proveedor of proveedores" [value]="proveedor.id">
            {{ proveedor.razon_social }}
          </option>
        </select>
        <small *ngIf="Proveedor.invalid && Proveedor.touched" class="text-danger">Campo Obligatorio</small>
      </div>

      <!-- 4. Ejercicio -->
      <div class="form-group col-md-2">
        <label>Ejercicio</label>
        <ng-container *ngIf="!folioYaCapturado">
          <input [(ngModel)]="Recargastock.ejercicio"
                 type="number"
                 class="form-control"
                 name="Ejercicio"
                 min="2000" max="2100"
                 (ngModelChange)="actualizarHabilitados()"
                 required>
        </ng-container>
        <ng-container *ngIf="folioYaCapturado">
          <input type="text" class="form-control bg-light text-muted" [value]="ejercicioFijado" readonly>
          <small class="text-muted"><span class="mdi mdi-lock-outline"></span> Ejercicio bloqueado</small>
        </ng-container>
      </div>

      <!-- 5. Folio factura -->
      <div class="form-group col-md-2">
        <label>Folio factura</label>
        <ng-container *ngIf="!folioYaCapturado">
          <input [(ngModel)]="Recargastock.folio"
                 type="text"
                 class="form-control"
                 name="Folio"
                 placeholder="Ej. FAC-001"
                 (ngModelChange)="actualizarHabilitados()"
                 required>
        </ng-container>
        <ng-container *ngIf="folioYaCapturado">
          <input type="text" class="form-control bg-light text-muted" [value]="folioFijado" readonly>
          <small class="text-muted"><span class="mdi mdi-lock-outline"></span> Folio bloqueado</small>
        </ng-container>
      </div>

    </div>

    <!-- FILA 2: Partida | Producto | Cantidad | Costo unitario | Importe | Total -->
    <div class="form-row mt-2">

      <!-- 6. Partida -->
      <div class="form-group col-md-4">
        <label>Partida</label>
        <select [(ngModel)]="Recargastock.partida"
                class="form-control"
                name="Partida"
                (change)="opcionSeleccionadaX(); actualizarHabilitados()"
                required
                #Partida="ngModel"
                [disabled]="!partidaHabilitada">
          <option value="" disabled selected>Seleccione la partida...</option>
          <option *ngFor="let stock of partidas" [value]="stock.id">
            {{ stock.clave }} -- {{ stock.descripcion }}
          </option>
        </select>
        <small *ngIf="Partida.invalid && Partida.touched" class="text-danger">
          <strong>Campo Obligatorio</strong>
        </small>
      </div>

      <!-- 7. Producto -->
      <div class="form-group col-md-4">
        <label>Producto <small class="text-muted">(Busque y selecciónelo cuidadosamente)</small></label>
        <input type="text"
               class="form-control"
               placeholder="Escriba el nombre del producto..."
               [(ngModel)]="terminoBusqueda"
               name="Busqueda"
               (input)="buscarYSeleccionar()"
               list="listaProductos"
               [attr.disabled]="!productoHabilitada ? '' : null">
        <datalist id="listaProductos">
          <option *ngFor="let p of productosFiltrados" [value]="p.descripcion"></option>
        </datalist>
      </div>

      <!-- Cantidad -->
      <div class="form-group col-md-1">
        <label>Cantidad adq.</label>
        <input [(ngModel)]="Recargastock.cantidad"
               type="number"
               class="form-control"
               name="Cantidad"
               min="1"
               (input)="CalcularImporteyTotal(); actualizarHabilitados()"
               [attr.disabled]="!cantidadHabilitada ? '' : null"
               required>
      </div>

      <!-- Costo unitario -->
      <div class="form-group col-md-1">
        <label>Costo unitario</label>
        <input type="text"
               class="form-control"
               name="CostoUnitario"
               [value]="costo_unitario | currency"
               readonly>
      </div>

      <!-- Importe -->
      <div class="form-group col-md-1">
        <label>Importe</label>
        <input type="text" [value]="monedaFormateada" class="form-control" readonly>
      </div>

      <!-- Total de compra -->
      <div class="form-group col-md-1">
        <label>Total compra</label>
        <input type="text" [value]="monedaFormateada2" class="form-control" readonly>
      </div>

    </div>

    <!-- Botón Agregar a la lista -->
    <div class="mt-3 mb-4" style="text-align: center;">
      <button type="submit"
              class="btn btn-success px-4"
              [disabled]="f.invalid || articuloValido === false">
        <span class="mdi mdi-plus-circle-outline"></span>&nbsp; Agregar a la lista
      </button>
    </div>

  </form>
</div>

<!-- Tabla acumuladora -->
<div *ngIf="tablaArticulos.length > 0" class="px-3 mt-2 mb-5">

  <hr>
  <h5 class="mb-3">
    <span class="mdi mdi-clipboard-list-outline"></span>
    &nbsp;Artículos listos para guardar
    <span class="badge bg-secondary ms-2">{{ tablaArticulos.length }}</span>
  </h5>

  <div class="table-responsive">
    <table class="table table-bordered table-hover table-sm align-middle">
      <thead class="table">
        <tr>
          <th>#</th>
          <th>Núm. Consec.</th>
          <th>Fecha compra</th>
          <th>Ejercicio</th>
          <th>Producto</th>
          <th>Proveedor</th>
          <th>Folio</th>
          <th class="text-center">Cantidad</th>
          <th class="text-end">Costo Unitario</th>
          <th class="text-end">Importe</th>
          <th class="text-end">Total c/IVA</th>
          <th class="text-center">Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let articulo of tablaArticulos; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ articulo.numeroConsecutivo }}</td>
          <td>{{ articulo.fechaAd }}</td>
          <td>{{ articulo.ejercicio }}</td>
          <td>{{ articulo.productoDesc }}</td>
          <td>{{ articulo.proveedorDesc }}</td>
          <td><span class="badge bg-info text-dark">{{ articulo.folio }}</span></td>
          <td class="text-center">{{ articulo.cantidad }}</td>
          <td class="text-end">{{ articulo.costoUnitario | currency }}</td>
          <td class="text-end">{{ articulo.importe | currency }}</td>
          <td class="text-end">{{ articulo.totalCompra | currency }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-danger btn-sm" (click)="EliminarFila(i)">
              <span class="mdi mdi-delete-outline"></span>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot class="table-secondary fw-bold">
        <tr>
          <td colspan="8" class="text-end">Totales:</td>
          <td class="text-end">{{ totalImporteTabla | currency }}</td>
          <td class="text-end">{{ totalCompraTabla | currency }}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="text-center mt-3">
    <button type="button"
            class="btn btn-primary btn-lg px-5"
            (click)="GuardarTodo()"
            [disabled]="guardandoTodo">
      <span *ngIf="!guardandoTodo">
        <span class="mdi mdi-content-save-all-outline"></span>&nbsp; Guardar todo el stock
      </span>
      <span *ngIf="guardandoTodo">
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        Guardando...
      </span>
    </button>
  </div>

</div>